import script from "./DefBannerMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefBannerMedia.vue?vue&type=script&lang=ts&setup=true"

import "./DefBannerMedia.vue?vue&type=style&index=0&id=7e5c5109&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5c5109"]])

export default __exports__